document.addEventListener('DOMContentLoaded', function () {
  const VARIANTS = {
    '51062480961810': {
      quantity: 1,
      minimum: 1
    },
    '51062480994578': {
      quantity: 1,
      minimum: 1
    },
    '51062481027346': {
      quantity: 4,
      minimum: 3
    }
  };

  /*
   * Find every variant picker on the page that has a form-id.
   * This supports both the top and bottom product forms.
   */
  const variantPickers = document.querySelectorAll(
    'variant-picker[form-id]'
  );

  if (!variantPickers.length) return;

  variantPickers.forEach(function (variantPicker) {
    const FORM_ID = variantPicker.getAttribute('form-id');

    if (!FORM_ID) return;

    const form = document.getElementById(FORM_ID);

    if (!form) return;

    let lastVariantId = null;

    function getVariantInput() {
      return form.querySelector('input[name="id"]');
    }

    function getQuantityInput() {
      return document.getElementById(FORM_ID + '-quantity');
    }

    function getVariantId() {
      const variantInput = getVariantInput();
      return variantInput ? variantInput.value : null;
    }

    function applyQuantity() {
      const variantId = getVariantId();
      const settings = VARIANTS[variantId];

      if (!settings) return;

      const quantityInput = getQuantityInput();

      if (!quantityInput) return;

      /*
       * Don't repeatedly process the same variant.
       */
      if (variantId === lastVariantId) return;

      lastVariantId = variantId;

      /*
       * Set the correct minimum BEFORE setting the value.
       */
      quantityInput.setAttribute(
        'min',
        String(settings.minimum)
      );

      quantityInput.setAttribute(
        'mm-min',
        String(settings.minimum)
      );

      quantityInput.setAttribute('step', '1');
      quantityInput.setAttribute('mm-step', '1');

      /*
       * Set the default quantity.
       *
       * IMPORTANT:
       * We deliberately do NOT fire input/change events here.
       * This prevents MinMaxify / Shopify / Appstle from
       * unnecessarily rebuilding the purchase buttons.
       */
      quantityInput.value = String(settings.quantity);
      quantityInput.defaultValue = String(settings.quantity);

      quantityInput.style.setProperty(
        '--quantity-input-characters-count',
        String(settings.quantity).length + 'ch'
      );
    }

    /*
     * Initial page load.
     *
     * Shopify/Appstle may still be initializing, so wait briefly.
     */
    setTimeout(applyQuantity, 100);

    /*
     * Variant picker change.
     *
     * Shopify updates the hidden variant ID after the radio
     * button changes, so wait for that update.
     */
    variantPicker.addEventListener('change', function () {
      let attempts = 0;

      function waitForVariant() {
        attempts++;

        const variantId = getVariantId();

        if (VARIANTS[variantId]) {
          applyQuantity();
          return;
        }

        if (attempts < 10) {
          setTimeout(waitForVariant, 50);
        }
      }

      waitForVariant();
    });

    /*
     * Shopify sometimes replaces the hidden variant input.
     * Watch this specific form for that happening.
     */
    const formObserver = new MutationObserver(function () {
      const variantId = getVariantId();

      if (
        variantId &&
        variantId !== lastVariantId &&
        VARIANTS[variantId]
      ) {
        applyQuantity();
      }
    });

    formObserver.observe(form, {
      childList: true,
      subtree: true
    });
  });
});